var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlerts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Alerts, Warning, Signs Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18 9C18.6213 9 19.125 9.50368 19.125 10.125V16.875H25.875C26.4963 16.875 27 17.3787 27 18C27 18.6213 26.4963 19.125 25.875 19.125H19.125V25.875C19.125 26.4963 18.6213 27 18 27C17.3787 27 16.875 26.4963 16.875 25.875V19.125H10.125C9.50368 19.125 9 18.6213 9 18C9 17.3787 9.50368 16.875 10.125 16.875H16.875V10.125C16.875 9.50368 17.3787 9 18 9Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlerts);
export default __webpack_public_path__ + "static/media/Alerts.fa2d3ad5e95e354d0c76c694f4cd4e9b.svg";
export { ForwardRef as ReactComponent };